import { 
  Container, 
  Typography, 
  Box, 
  Button, 
  Paper 
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Brynleigh Estates HOA</title>
        <meta name="description" content="The page you are looking for does not exist. Return to the Brynleigh Estates homepage or browse our resources." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <Container maxWidth="md">
        <Box 
          sx={{ 
            my: 8, 
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh'
          }}
        >
          <Paper 
            elevation={0}
            sx={{ 
              p: 5, 
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
              maxWidth: 550,
              mx: 'auto'
            }}
          >
            <Typography 
              variant="h1" 
              color="primary"
              sx={{ 
                fontWeight: 700, 
                fontSize: '6rem',
                mb: 2
              }}
            >
              404
            </Typography>
            
            <Typography variant="h4" component="h1" gutterBottom>
              Page Not Found
            </Typography>
            
            <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
              The page you are looking for might have been removed, had its name changed, 
              or is temporarily unavailable.
            </Typography>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
              <Button 
                variant="contained" 
                color="primary" 
                startIcon={<HomeIcon />}
                component={RouterLink}
                to="/"
                size="large"
              >
                Return Home
              </Button>
              
              <Button 
                variant="outlined" 
                startIcon={<SearchIcon />}
                component={RouterLink}
                to="/links"
                size="large"
              >
                Find Resources
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </>
  );
};

export default NotFound; 